import { writable, type Writable } from 'svelte/store';
import type { NotificationProps } from '../interfaces/Notification';

export const NotificationStore: Writable<NotificationProps> = writable();
